
import { computed, defineComponent, PropType, ref } from "vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseInput from "@/components/BaseInput.vue";
import BaseSelect from "@/components/BaseSelect.vue";
import { TLevel } from "@/game";

export default defineComponent({
  name: "Settings",
  components: { BaseSelect, BaseInput, BaseButton },
  props: {
    isPlaying: {
      type: Boolean,
      default: false,
    },
    isPaused: {
      type: Boolean,
      default: false,
    },
    levels: {
      type: Array as PropType<TLevel[]>,
      required: true,
    },
  },
  emits: ["started", "resumed"],
  setup(props) {
    let speed = ref(20);
    let level = ref(-1);

    const startButtonTitle = computed(() =>
      props.isPaused ? "restart" : "start"
    );

    return {
      speed,
      level,
      startButtonTitle,
    };
  },
});
